import {
  city,
  email,
  emailNotRequired,
  firstName,
  lastName,
  phone,
  privacyAgreement,
  street,
  streetNumber,
  zipcode,
} from '@/schemas';
import * as Yup from 'yup';

const withBillingAddress = <T>(schema: Yup.Schema<T>) =>
  schema.when('hasDifferentBillingAddress', {
    is: (value: boolean | string) => value === true || value === 'true',
    then: (schema) => schema.required(),
    otherwise: () => Yup.string().nullable(),
  });

export const formSchema = Yup.object({
  designation: Yup.string()
    .required('Bitte wählen Sie eine Anrede aus.')
    .oneOf(['Herr', 'Frau', 'Divers'], 'Bitte wählen Sie eine Anrede aus.'),
  firstName,
  lastName,
  company: Yup.string().required('Bitte geben Sie Ihren Firmennamen ein.'),
  postalCode: zipcode,
  city,
  street,
  streetNumber,
  email,
  phone,
  annotations: Yup.string(),
  billingEmail: emailNotRequired,
  hasDifferentBillingAddress: Yup.boolean(),
  billingFirstName: withBillingAddress(firstName),
  billingLastName: withBillingAddress(lastName),
  billingCompany: withBillingAddress(
    Yup.string().required('Bitte geben Sie Ihren Firmennamen ein.')
  ),
  billingPostalCode: withBillingAddress(zipcode),
  billingCity: withBillingAddress(city),
  billingStreet: withBillingAddress(street),
  billingStreetNumber: withBillingAddress(streetNumber),
  marketingAgreement: Yup.boolean(),
  privacyAgreement,
});
